import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { MessageService } from 'src/app/services/message-service/message.service';

@Component({
    selector: 'app-mm-menu-header',
    templateUrl: './mm-menu-header.component.html',
    styleUrls: ['./mm-menu-header.component.scss'],
})
export class MmMenuHeaderComponent implements OnInit {

    public modelLocator: ModelLocatorService;

    protected router: Router;

    public menuInteracao: boolean = false;
    public menuLoja: boolean = false;
    public menuSuperacao: boolean = false;
    public menuInformacao: boolean = false;
    public menuPlanos: boolean = false;

    constructor(
        injector: Injector,
        modelLocatorService: ModelLocatorService,
        private messageServive: MessageService,
        private http: HttpClient,
    ) {
        this.router = injector.get(Router);
        this.modelLocator = modelLocatorService;
    }

    async ngOnInit() {

        await this.carregaSaldo();
        await this.carregaPtsExpirar();

        if (!this.modelLocator.dadosLogin.email) {
            this.consultaDados();
        }

    };

    async carregaSaldo() {

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v2/extrato/totais';

            this.http.get(url, config).subscribe(
                (data: any) => {
                    if (data['status'] == 200) {
                        this.modelLocator.saldo = data['result'];
                    }
                },
                (err) => {
                    console.log("Error:", err);

                    if (err['status'] == 401) {
                        alert(err.error.message);
                        this.modelLocator.logado = false;
                        localStorage.clear();
                        this.modelLocator.urlretorno = '';
                        this.router.navigate(['/login']);
                    } else {
                        this.modelLocator.saldo = 0;
                        this.messageServive.showToast('Erro ao processar saldo.', 'warning', 'bottom', 5000, true);
                    }
                }
            );

        } catch (err) {
            this.modelLocator.saldo = 0;
            return this.messageServive.showToast('Erro ao processar saldo.', 'warning', 'bottom', 5000, true);
        }

    };

    carregaPtsExpirar() {

        //console.log('pontos expirar: ');

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/extrato/expirar';

            this.http.get(url, config)
                .subscribe({


                    next: (data) => {

                        if (data['status'] == 200) {
                            this.modelLocator.pts_expirar = data['pts_expirar'];
                        }

                        //console.log(this.modelLocator.pts_expirar);

                    }, error: (err) => {
                        console.log("🚀 ~ file: mm-menu-header.component.ts:126 ~ MmMenuHeaderComponent ~ carregaPtsExpirar ~ err:", err)

                        this.modelLocator.pts_expirar = 0;
                        return this.messageServive.showToast('Erro ao processar pontos a expirar.', 'warning', 'bottom', 5000, true);

                    }
                });

        } catch (err) {
            this.modelLocator.pts_expirar = 0;
            return this.messageServive.showToast('Erro ao processar pontos a expirar.', 'warning', 'bottom', 5000, true);
        }


        return;
    };

    consultaDados() {

        //console.log('>>>>> consultaDados()');

        try {

            let config = {
                headers: {
                    "x-token": this.modelLocator.configUso.X_TOKEN_API,
                    "auth-token": this.modelLocator.dadosLogin.hash_auth
                },
                params: {
                    "cpf": this.modelLocator.dadosLogin.cpf
                }
            };

            let url = this.modelLocator.configUso.urlApiPadrao + 'auth/hotsite/v1/usuario/consulta';

            this.http.get(url, config)
                .subscribe(data => {

                    if (data['status'] == 200) {

                        this.modelLocator.dadosLogin.email = data['result'].email;
                        this.modelLocator.dadosLogin.celular = data['result'].celular;
                        this.modelLocator.dadosLogin.sexo = data['result'].sexo;
                        this.modelLocator.dadosLogin.nascimento = data['result'].nascimento;

                        localStorage.setItem('AUTH', JSON.stringify(this.modelLocator.dadosLogin));

                        //console.log('>>>>> dadosLogin:' + JSON.stringify(this.modelLocator.dadosLogin));

                    }

                });

        } catch (error) {

        }

    }

    touchGoToRoute(rota: string) {
        this.router.navigate([rota]);
    };

    logout() {

        this.modelLocator.logado = false;
        localStorage.clear();
        this.modelLocator.urlretorno = '';
        this.router.navigate(['/login']);

    };

}
